import { getColor } from 'helpers';
import { CSSObject, styled } from 'libs/ui/styled';
import { ColorsDark, ColorsLight } from 'libs/ui/theme';

export const FormFooterStyled = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('mobile')]: {
    margin: '0 -24px',
    padding: '20px 24px',
    marginTop: 8,

    borderTop: `1px solid ${getColor(theme, {
      dark: ColorsDark.gray100,
      light: ColorsLight.gray150,
    })}`,
  } as CSSObject,
}));
